<!-- =========================================================================================
    File Name: VxTour.vue
    Description: Tour Component
    ----------------------------------------------------------------------------------------
    Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
      Author: Pixinvent
    Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
    <div>
        <div class="vx-row items-center mb-2">
            <v-select class="mr-2 " style="width:200px"
                name='name'
                label="name"
                placeholder="언어"
                v-model="lang"
                :options="languageOption"
                :reduce="languageOption => languageOption.code"
                :clearable="false"
                />
            <vs-input v-model="name" class="" :placeholder="title"/>
            <vs-button class="ml-3 small" style="vertical-align:top; height:30px;" color="success" @click="add" type="gradient">추가</vs-button>
        </div>
        <!-- <ul >
            <li class="vx-row items-center mb-2" v-for="(item, key) in langList">
                <v-select class="mr-2" style="width:130px"
                    name='name'
                    label="name"
                    placeholder="앨범명(번역)" 
                    v-model="key"
                    :options="languageOption"
                    :reduce="languageOption => languageOption.code" 
                    :clearable="false" 
                    disabled/>
                <vs-input @input="update(key, $event)" :value="langList[key]" class="" placeholder="앨범명(번역)"/>
                <vs-button class="ml-3 small" style="vertical-align:top; height:30px;" color="danger" @click="del" type="gradient">삭제</vs-button>
            </li>
        </ul> -->
        <vs-table :data="[]" class="mt-4 w-full" >
            <template slot="thead">
                <vs-th style="width:150px">국가언어</vs-th>
                <vs-th>{{title ? title : '이름'}}</vs-th>
                <vs-th></vs-th>
            </template>
            <template v-for="(item, key) in langList">
                <vs-tr>
                    <vs-td width="1">
                        <v-select class="mr-2 w-full" style="width:100%"
                        name='name'
                        label="name"
                        placeholder="앨범명(번역)" 
                        v-model="key"
                        :options="languageOption"
                        :reduce="languageOption => languageOption.code" 
                        :clearable="false" 
                        disabled/>
                    </vs-td>
                    <vs-td >
                        <!-- {{ data[indextr].name }} -->
                       <vs-input @input="update(key, $event)" :value="langList[key]" class="w-full" placeholder="앨범명(번역)"/>
                    </vs-td>
                    <vs-td width="160px" >
                        <vs-button class="ml-3 small" style="vertical-align:top; height:30px; width:100px;" color="danger" @click="del(key)" type="gradient">삭제</vs-button>
                    </vs-td>
                </vs-tr>
            </template>
        </vs-table>
    </div>
</template>

<script>

import optionData from '@/optionData/data'

export default{
    name: 'multi-lang',
    props: {
        langList: {
            type: Object,
            default: () => ({})
        },
        title: {
            type: String,
            default: ''
        }
    },
    data () {
        return{
            name : null,
            lang : null,
            languageOption : optionData.language,
        }
    },
    watch: {
        'langList'(){
            
        }
    },
    mounted () {
    },
    methods:{
        update(name,val){
            this.langList[name] = val
            this.$forceUpdate()
            this.$emit('changeUpdate', this.langList)
        },
        add(){
            if(this.lang && this.name){
                console.log(this.langList);
                if(!this.langList[this.lang] ){
                    this.langList[this.lang] = this.name
                    this.lang = null    
                    this.name = null
                    this.$forceUpdate()
                    this.$emit('changeUpdate', this.langList)
                }else{
                    this.noti('이미 등록된 언어 입니다.')    
                }
            }else{
                this.noti('언어와 앨범명을 입력하세요.')
            } 
        
        },
        del(data){
            delete this.langList[data]
            this.$forceUpdate()
            this.$emit('changeUpdate', this.langList)
        }
    }
}
</script>

<style lang="scss">

</style>
